import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    authors: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false,
    author: {
      id: null,
      name: '',
      description: null,
      bio: null,
      short_bio: null,
      company: null
    }
  },

  mutations: {
    setAuthors(state, payload) {
      state.authors = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedAuthor(state, payload) {
      state.author = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/blog-author', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setAuthors', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/blog-author/' + id, {
          name: state.author.name,
          description: state.author.description,
          bio: state.author.bio,
          short_bio: state.author.short_bio,
          company: state.author.company,
          picture: state.author.picture
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedAuthor', {})
          dispatch('read')
        })
    },
    delete({ dispatch }, id) {
      axios.admin.put('cms/blog-author/delete/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/blog-author', {
          id: state.author.id,
          name: state.author.name,
          description: state.author.description,
          bio: state.author.bio,
          short_bio: state.author.short_bio,
          company: state.author.company,
          picture: state.author.picture
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedAuthor', {})
          dispatch('read')
        })
    }
  },

  getters: {}
}
